export default "__VITE_ASSET__8002ae4e__"